import { useProductDetails } from '../../../hooks/product/useProductDetails';
export const useSubtextDisplayProductDetails = ({
  productApiName
}) => {
  // Basic product details
  const {
    productDetails,
    loading
  } = useProductDetails({
    productApiName
  });
  const productLevel = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productLevel;
  const skuCategoryName = productDetails === null || productDetails === void 0 ? void 0 : productDetails.skuCategoryName;
  const quantityPacks = productDetails === null || productDetails === void 0 ? void 0 : productDetails.quantityPacks;

  // Matching quantity pack for the product
  const matchingQuantityPack = quantityPacks === null || quantityPacks === void 0 ? void 0 : quantityPacks.find(quantityPack => {
    return quantityPack.skuCategoryName === skuCategoryName;
  });
  const additionalUnitSkuId = matchingQuantityPack === null || matchingQuantityPack === void 0 ? void 0 : matchingQuantityPack.skuId;
  const quantityName = matchingQuantityPack === null || matchingQuantityPack === void 0 ? void 0 : matchingQuantityPack.quantityName;
  const includedWithParentProduct = matchingQuantityPack === null || matchingQuantityPack === void 0 ? void 0 : matchingQuantityPack.includedWithParentProduct;
  return {
    productLevel,
    skuCategoryName,
    additionalUnitSkuId,
    quantityName,
    includedWithParentProduct,
    loading
  };
};